import { forwardRef, type Ref, type SVGProps } from "react";
const IconCalendarOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <rect width={4} height={4} x={8} y={16} rx={0.5} />
    <rect width={4} height={4} x={20} y={16} rx={0.5} />
    <rect width={4} height={4} x={14} y={16} rx={0.5} />
    <rect width={4} height={4} x={8} y={22} rx={0.5} />
    <rect width={4} height={4} x={20} y={22} rx={0.5} />
    <rect width={4} height={4} x={14} y={22} rx={0.5} />
    <path d="M25 5h-1V3a1 1 0 0 0-2 0v2H10V3a1 1 0 0 0-2 0v2H7a3 3 0 0 0-3 3v19a3 3 0 0 0 3 3h18a3 3 0 0 0 3-3V8a3 3 0 0 0-3-3M7 7h1v2a1 1 0 0 0 2 0V7h12v2a1 1 0 0 0 2 0V7h1a1 1 0 0 1 1 1v4H6V8a1 1 0 0 1 1-1m18 21H7a1 1 0 0 1-1-1V14h20v13a1 1 0 0 1-1 1" />
  </svg>
);
const ForwardRef = forwardRef(IconCalendarOutlineSVG);
ForwardRef.displayName = "IconCalendarOutline";
export { ForwardRef as IconCalendarOutline };
